<app-stopwatch [data]="data" [presentStopwatchSeconds]="fieldConfig.presentStopwatchSeconds"></app-stopwatch>
